






































































































import { Component, Vue, Prop,Ref, Watch } from 'vue-property-decorator';

@Component({
  components: {  }
})
export default class invoice extends Vue {

  @Ref('defaultConfigDrawer') defaultConfigDrawer
  @Prop(Object) detailInfo;
  @Watch('detailInfo',{immediate:true,deep:true})
  detailInfoChange(newVal){
    console.log(newVal);

  }
  form: any = {
    name: '123'
  };
  drawer:boolean = false;
  showMoreInfo:boolean =false;
  size:string = '600px';
  radio1:string = '';
  radio2:string = '';
  radio3:string = '';
  tableData1:Array<object> = [{
    name:'',
    tin:'',
    companyAddress:'',
    telephone:'',
    openingBank:'',
    accountNumber:''
  }
  ];
  edit() {
    // this.drawer = true;
    this.defaultConfigDrawer.openDrawer()
  }
   showMore(){
  this.showMoreInfo = true
  }
   showMore2(){
  this.showMoreInfo = false
  }
}
